import React from 'react';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';
import { InputWrapper } from '../css';
import { Box, Text } from '../../design/css';

const TypeAhead = ({
  options,
  onChange,
  selected,
  label,
  placeholder,
  disabled
}) => {
  // const ref = useRef();

  // useEffect(() => {
  //   if (!selected.length) {
  //     ref.current.clear();
  //   }
  // }, [selected]);

  return (
    <InputWrapper style={{ marginTop: '55px' }}>
      <Box>
        <Text bold>{label}</Text>
        <Typeahead
          id="basic-typeahead"
          labelKey="label"
          disabled={disabled}
          options={options}
          onChange={onChange}
          placeholder={placeholder}
          selected={selected}
          clearButton
        />
      </Box>
    </InputWrapper>
  );
};

TypeAhead.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

TypeAhead.defaultProps = {
  selected: [],
  disabled: false
};

export default TypeAhead;
